import React from 'react'
import { Button } from 'react-bootstrap'
import './usercheck.css'
const UserCheck = ({buttonHandle, isDisable}) => {

    return (
        
        <div className="box-container">

                <div className="panel-box">
                    <h4>Log in to win</h4>
                    <Button onClick={() => buttonHandle(true)} style={{backgroundColor: '#5C1DC0', border: 0, fontWeight: 600}}>Login</Button>
                </div>
                <div className="panel-box">
                    <h4>Are you new to us?</h4>
                    {isDisable ? 
                    <Button title='You already a member' style={{backgroundColor: '#767676', border: 0, fontWeight: 600}}>Sign Up</Button>
                    :
                    <Button onClick={() => buttonHandle(false)} style={{backgroundColor: '#2343CE', border: 0, fontWeight: 600}}>Sign Up</Button>}
                </div>
        </div>
    )
}

export default UserCheck